/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface MangimificioCreateDTO
 */
export interface MangimificioCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    idNazione: string;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MangimificioCreateDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MangimificioCreateDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof MangimificioCreateDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the MangimificioCreateDTO interface.
 */
export function instanceOfMangimificioCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idNazione" in value;

    return isInstance;
}

export function MangimificioCreateDTOFromJSON(json: any): MangimificioCreateDTO {
    return MangimificioCreateDTOFromJSONTyped(json, false);
}

export function MangimificioCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MangimificioCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function MangimificioCreateDTOToJSON(value?: MangimificioCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

